module.exports = __webpack_public_path__ + "img/step2.9c6f5740.png";